module.exports = __webpack_public_path__ + "img/Connexion.9625160f.svg";